import { ReactNode } from 'react';
import Color from '../../utilities/Color.js';
import { IconType } from '../Icon/Icon.types.js';
import Icon from '../Icon/index.js';
import Markdown from '../Markdown/index.js';

export interface BulletProps {
  icon: IconType;
  title: ReactNode;
  description?: string;
  iconColor?: Color;
}

const Bullet = ({ icon, title, description, iconColor }: BulletProps): JSX.Element => {
  return (
    <li className="flex flex-col">
      <div className="flex items-center gap-x-3">
        <Icon color={iconColor || Color.Text} type={icon} size="LG" />
        {title}
      </div>
      {description && (
        <div className="ml-9">
          <Markdown variant="body">{description}</Markdown>
        </div>
      )}
    </li>
  );
};

export default Bullet;
